module.exports = __webpack_public_path__ + "static/media/iphone3-1.c9d3accb.png";